<template>
	<b-container>
		<div>
			<b-tabs content-class="mt-3">
				<b-tab title="Service Contracts" active>
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Invoice Codes" active>
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right mb-3"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'invoicecode';
														modalTitle = 'Add Invoice code';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Code</th>
													<th>Price</th>
													<th style="width: 12.5%"></th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(code, index) in invoiceCodes" :key="index + 10">
													<td v-if="code.Editable">
														<b-form-input v-model="code.Code" type="text" />
													</td>
													<td v-else>
														{{ code.Code }}
													</td>

													<td v-if="code.Editable">
														<b-form-input v-model="code.Price" type="text" />
													</td>
													<td v-else>&pound;{{ code.Price }}</td>

													<td>
														<b-link v-if="!code.Editable" class="ml-3 float-right" @click.prevent="deleteInvoiceCode(index)" title="Delete this code"> <b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon> </b-link
														><save-or-edit-buttons-row :section="code" @save="updateInvoiceCode(code)"></save-or-edit-buttons-row>
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-tab>

				<b-tab title="Clocks">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Types" active>
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'clocktype';
														modalTitle = 'Add Clock Type';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Name</th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(clocktype, index) in clockTypes" :key="index + 10">
													<td>
														{{ clocktype.Name }}
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>

							<b-tab title="Equipment">
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'equipment';
														modalTitle = 'Add Equipment';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Name</th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(component, index) in components" :key="index + 10">
													<td>
														{{ component.Name }}
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>

							<b-tab title="Chimes">
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'chimes';
														modalTitle = 'Add Chime';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Name</th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(chime, index) in quarterChimes" :key="index + 10">
													<td>
														{{ chime.DisplayName }}
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>

							<b-tab title="Dials">
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'dialTypes';
														modalTitle = 'Add Dial';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Name</th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(dial, index) in dialTypes" :key="index + 10">
													<td>
														{{ dial.Name }}
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>

							<b-tab title="Escapements">
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'escapements';
														modalTitle = 'Add Escapement';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Name</th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(escapement, index) in escapements" :key="index + 10">
													<td>
														{{ escapement.Name }}
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-tab>

				<b-tab title="Jobs">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Materials" active>
								<b-card-text>
									<b-form-fieldset>
										<b-row class="mt-3">
											<b-col>
												<b-link
													class="float-right"
													title="Add Material Type"
													v-b-modal.sharedModal
													@click.prevent="
														modalContent = 'material';
														modalTitle = 'Add Material Type';
													"
												>
													<b-icon font-scale="1.5" icon="plus-square"></b-icon>
												</b-link>
											</b-col>
										</b-row>

										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th colspan="2">Type</th>
													<th>Materials</th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(material, index) in materials" :key="index + 10">
													<td v-if="material.Editable">
														<b-form-input v-model="material.Name" type="text" />
													</td>

													<td v-else>
														{{ material.Name }}
													</td>

													<td>															
														<b-link v-if="!material.Editable" class="ml-3 float-right" @click.prevent="deleteMaterial(index)" title="Delete this material type?">
															<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
														</b-link>

														<save-or-edit-buttons-row :section="material" @save="updateMaterial(material)"></save-or-edit-buttons-row>
													</td>

													<td>
														<b-link
															class="ml-3  float-right"
															v-b-modal.sharedModal
															title="Add Material"
															@click.prevent="
																modalContent = 'submaterial';
																modalTitle = 'Add Submaterial';
																selectedMaterialId = material.Id;
															"
														>
															<b-icon font-scale="1.5" icon="plus-square" title="Add a new material?"></b-icon>
														</b-link>
														<b-table-simple small fixed>
															<tr v-for="(subMaterial, lineIndex) in material.SubMaterials" :key="lineIndex + 10">
																<td v-if="subMaterial.Editable">
																	<b-form-input v-model="subMaterial.Name" type="text" />
																</td>
																<td v-else>
																	{{ subMaterial.Name }}
																</td>

																<td>
																	<b-link v-if="!subMaterial.Editable" class="ml-3 float-right" @click.prevent="deleteSubMaterial(index, lineIndex)" title="Delete this material?">
																		<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
																	</b-link>

																	<save-or-edit-buttons-row :section="subMaterial" @save="updateMaterial(material)"></save-or-edit-buttons-row>
																</td>
															</tr>
														</b-table-simple>
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-tab>

				<b-tab title="Rest stops">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Rest stops" active>
								<b-card-text>
									<b-form-fieldset>
										<b-table-simple small fixed>
											<b-thead head-variant="light">
												<tr>
													<th>Name</th>
													<th>Email Address</th>
													<th>Telephone</th>
													<th>Mobile</th>
													<th>Description</th>
													<th></th>
												</tr>
											</b-thead>

											<b-tbody>
												<tr v-for="(stop, index) in restStops" :key="index + 10">
													
													<td v-if="stop.Editable">
														<b-form-input v-model="stop.Name" type="text" />
													</td>
													<td v-else>
														{{ stop.Name }}
													</td>

													<td v-if="stop.Editable">
														<b-form-input v-model="stop.EmailAddress" type="text" />
													</td>
													<td v-else>
														{{ stop.EmailAddress }}
													</td>

													<td v-if="stop.Editable">
														<b-form-input v-model="stop.Telephone" type="text" />
													</td>
													<td v-else>
														{{ stop.Telephone }}
													</td>

													<td v-if="stop.Editable">
														<b-form-input v-model="stop.Mobile" type="text" />
													</td>
													<td v-else>
														{{ stop.Mobile }}
													</td>

													<td v-if="stop.Editable">
														<b-form-input v-model="stop.Description" type="text" />
													</td>
													<td v-else>
														{{ stop.Description }}
													</td>

													<td>
														<b-link v-if="!stop.Editable" class="ml-3 float-right" @click.prevent="deleteRestStop(index)" title="Delete this stop"> <b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon> </b-link
														><save-or-edit-buttons-row :section="stop" @save="updateRestStop(stop)"></save-or-edit-buttons-row>
													</td>
												</tr>
											</b-tbody>
										</b-table-simple>
									</b-form-fieldset>
								</b-card-text>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-tab>
			</b-tabs>
		</div>

		<b-modal id="sharedModal" ref="sharedModal" :title="modalTitle" hide-footer>

			<add-invoice-code v-if="modalContent == 'invoicecode'" @addInvoiceCode="addInvoiceCode" />

			<add-clock-type v-if="modalContent == 'clocktype'" @addClockType="addClockType" />

			<add-equipment v-if="modalContent == 'equipment'" @addEquipment="addEquipment" />

			<add-material v-if="modalContent == 'material'" @addMaterial="addMaterial" />

			<add-sub-material v-if="modalContent == 'submaterial'" @addSubMaterial="addSubMaterial" :materialId="selectedMaterialId" />

		</b-modal>

		<confirm ref="confirm"></confirm>

	</b-container>
</template>

<script>
import InvoiceCodeService from '@/api-services/invoicecode.service';
import ClockService from '@/api-services/clock.service';
import ClockTypeService from '@/api-services/clocktype.service';
import DialTypeService from '@/api-services/dialtype.service';
import EquipmentService from '@/api-services/equipment.service';
import EscapementService from '@/api-services/escapement.service';
import MaterialService from '@/api-services/material.service';
import RestStopService from '@/api-services/reststop.service';

import SaveOrEditButtonsRow from '@/components/partials/save-or-edit-buttons-row';
import AddInvoiceCode from '@/components/partials/add-invoicecode';
import AddClockType from '@/components/partials/add-clocktype';
import AddEquipment from '@/components/partials/add-equipment';
import AddMaterial from '@/components/partials/add-material';
import AddSubMaterial from '@/components/partials/add-submaterial';

import Confirm from '@/components/partials/confirm';

export default {
	name: 'Settings',

	components: {
		AddInvoiceCode,
		AddClockType,
		AddEquipment,
		AddMaterial,
		AddSubMaterial,
		Confirm,
		SaveOrEditButtonsRow
	},

	data() {
		return {
			restStops: [],
			invoiceCodes: [],
			quarterChimes: [],
			clockTypes: [],
			components: [],
			dialTypes: [],
			escapements: [],
			materials: [{ SubMaterials: [{ MaterialId: '', Name: '' }] }],
			modalContent: null,
			modalTitle: 'Select',
			selectedMaterialId: null
		};
	},

	mounted() {
		this.fetchInvoiceCodes();
		this.fetchClockChimes();
		this.fetchClockTypes();
		this.fetchEquipment();
		this.fetchDials();
		this.fetchEscapements();
		this.fetchRestStops();
		
		this.fetchMaterials();
		
	},

	methods: {
		fetchMaterials() {
			MaterialService.getAll()
				.then((response) => {
					let tempMaterials = response.data;
					this.materials = tempMaterials;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchRestStops() {
			return RestStopService.getAll()
				.then((response) => {
					this.restStops = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchInvoiceCodes() {
			InvoiceCodeService.getAll()
				.then((response) => {
					this.invoiceCodes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchClockChimes() {
			ClockService.getEnum('chime')
				.then((response) => {
					this.quarterChimes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},
		fetchClockTypes() {
			ClockTypeService.getAll()
				.then((response) => {
					this.clockTypes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},
		fetchEquipment(component) {
			EquipmentService.getAll()
				.then((response) => {
					this.components = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},
		fetchDials() {
			DialTypeService.getAll()
				.then((response) => {
					this.dialTypes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},
		fetchEscapements() {
			EscapementService.getAll()
				.then((response) => {
					this.escapements = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		addInvoiceCode(newCode) {
			this.invoiceCodes.push(newCode),
				this.$nextTick(() => {
					this.modalContent = null;
					this.$refs.sharedModal.hide();
				});
		},

		addClockType(newType) {
			this.clockTypes.push(newType),
				this.$nextTick(() => {
					this.modalContent = null;
					this.$refs.sharedModal.hide();
				});
		},

		addEquipment(newComponent) {
			this.components.push(newComponent),
				this.$nextTick(() => {
					this.modalContent = null;
					this.$refs.sharedModal.hide();
				});
		},

		addMaterial(newItem) {
			this.materials.push(newItem),
				this.$nextTick(() => {
					this.modalContent = null;
					this.$refs.sharedModal.hide();
				});
		},

		addSubMaterial(newItem) {
			let foundMaterial = this.materials.filter((q) => {
				if (q.Id == newItem.MaterialId){

					q.SubMaterials.push(newItem);
				}
			});

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});

		},

		updateInvoiceCode(code) {
			InvoiceCodeService.update(code.Id, code).catch((error) => {
				this.handleError(error);
			});
		},

		updateRestStop(stop) {
			RestStopService.update(stop.Id, stop).catch((error) => {
				this.handleError(error);
			});
		},

		updateMaterial(material) {
			MaterialService.update(material.Id, material).catch((error) => {
				this.handleError(error);
			});
		},

		async deleteSubMaterial(index, lineIndex) {
			if (await this.$refs.confirm.open('Delete', 'Are you sure you want to delete this material?')) {		
				let typeArr = this.materials[index].SubMaterials;
				typeArr.splice(lineIndex, 1);
			
				this.updateMaterial(this.materials[index]);
			}
		},

		async deleteMaterial(index) {
			if (await this.$refs.confirm.open('Delete', 'Are you sure you want to delete this material?')) {
				let toDelete = this.materials[index];
				MaterialService.delete(toDelete.Id)
					.then(() => {
						this.$delete(this.materials, index);

						this.$refs.confirm.open('Success', 'Successfully deleted material', true);
					})
					.catch((error) => {
						this.handleError(error);
					});
			}
		},

		async deleteInvoiceCode(index) {
			if (await this.$refs.confirm.open('Delete', 'Are you sure you want to delete this code?')) {
				let toDelete = this.invoiceCodes[index];
				InvoiceCodeService.delete(toDelete.Id)
					.then(() => {
						this.$delete(this.invoiceCodes, index);

						this.$refs.confirm.open('Success', 'Successfully deleted code', true);
					})
					.catch((error) => {
						this.handleError(error);
					});
			}
		},

		async deleteRestStop(index) {
			if (await this.$refs.confirm.open('Delete', 'Are you sure you want to delete this rest stop?')) {
				let toDelete = this.restStops[index];
				RestStopService.delete(toDelete.Id)
					.then(() => {
						this.$delete(this.restStops, index);

						this.$refs.confirm.open('Success', 'Successfully deleted rest stop', true);
					})
					.catch((error) => {
						this.handleError(error);
					});
			}
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/settings/main.vue